import type { ScatterSeriesOption } from 'echarts';

import { lineVisuals } from '../config/chartVisuals';
import { LONE_POINTS_SERIES_ID } from '../config/componentIds';
import type { LonePointMarker } from './buildLineSeriesOption';

/**
 * A line that breaks across gaps in its data (see TimeSeries.gapThresholdMs) leaves a point with
 * a gap on both sides unconnected, and an unconnected point draws nothing. These dots show them.
 *
 * One scatter series holds the dots of every line, instead of switching each line's own symbols on:
 * a line with symbols processes every point it holds on each zoom and pan step, while this series
 * only ever holds the lone points. Each dot is placed on a fixed 0..1 axis at the height its line's
 * value axis gives it (a shared one when the line is in an axis group), and takes its line's colour and opacity.
 */
export function buildLonePointsOption(lonePoints: LonePointMarker[], yAxisIndex: number): ScatterSeriesOption {
  return {
    id: LONE_POINTS_SERIES_ID,
    type: 'scatter',
    yAxisIndex,
    silent: true,
    // Dots come and go as the user pans; they must appear in place, not pop in.
    animation: false,
    symbolSize: lineVisuals.lonePointSize,
    z: lineVisuals.highlightedZ,
    emphasis: { disabled: true },
    data: lonePoints.map(({ timestamp, position, color, opacity }) => ({
      value: [timestamp, position],
      itemStyle: { ...(color && { color }), opacity },
    })),
  };
}
